export default __webpack_public_path__ + "static/v_detect-d7f225de1204678b0982795fd66dc801.png";